<div class="bottom-sheet-container">
  <div class="row">
    <div class="col-12 top-dialog">
      <button type="button" mat-dialog-close class="dialog-close">
        <mat-icon class="close-button">close</mat-icon>
      </button>
    </div>
    <div class="col-12 bottomsheet-question margin-bottom">
      <span>
        <p>{{ 'csa.claiming.bottomsheet.title' | translate }}</p>
      </span>
    </div>
    <div class="col-12 bottomsheet-text margin-bottom">
      <span>
        <p>
          {{ 'csa.claiming.bottomsheet.question' | translate }}
        </p>
      </span>
    </div>
    <div class="col-12">
      <button class="white-btn" (click)="handleStopClaimingCLick()">{{ 'csa.claiming.bottomsheet.button' | translate }}</button>
    </div>
  </div>
</div>
